import React from "react";

import { UseFormReturn } from "react-hook-form";
import { ManageContentListProps, ManageContentListState } from "./models";
import { withUseFormHook } from "@sinossi/mates-react-library";

import {
	t,
	Trans
} from "@lingui/macro";

import {
	Box, Button, Typography
} from "@mui/material";

import * as Yup from "yup";

import { ContentListDataModel } from "models";
import { ContentProducerService } from "services/content-producer-service";
import { DefaultTypedResponse } from "models/response";
import ZPlayLoader from "commons/zplay-loader";
import NavigationBack from "commons/navigation/navigation-back/navigation-back";
import { WithSnackbarProps, withSnackbar } from "notistack";
import AddIcon from "@mui/icons-material/Add";
import {RouteComponentProps, withRouter} from "react-router-dom";
import ContentListTable from "components/backoffice/content-list/content-list-table/content-list-table";

const ManageContentListSchema = Yup.object().shape({
	title: Yup.string().max(50)
});

class ManageContentList extends React.Component<ManageContentListProps & UseFormReturn & WithSnackbarProps & RouteComponentProps<any>, ManageContentListState>
{
	constructor(props: any) {

		super(props);

		this.state = {
			searchFilter: null,
			pagination: { pageSize: 20, pageIndex: 0 },
			contentLists: [],
			contentListsCount: 0,
			data: null,
			loaded: false
		};
	}

	public componentDidMount() {
		ContentProducerService.getContentList([["pageId", this.state.pagination.pageIndex + 1], ["pageSize", this.state.pagination.pageSize]], this.getContentListsCallback, this.getcContentListsErrorCallback);
	}

	private getContentListsCallback = (data: DefaultTypedResponse<ContentListDataModel>): void => {

		this.setState(() => ({
			contentListsCount: data.size,
			contentLists: data.list,
			loaded: true
		}));

	};

	private getcContentListsErrorCallback = (err: any): void => {

		this.setState(() => ({
			loaded: false
		}));

	};

	private parseQueryParamsFromState = (values: any): [string, any][] => {

		let queryParamsToReturn: [string, any][] = [];

		queryParamsToReturn.push(["pageId", this.state.pagination.pageIndex + 1]);
		queryParamsToReturn.push(["pageSize", this.state.pagination.pageSize]);

		if (values.title && values.title !== "")
			queryParamsToReturn.push(["searchText", values.title]);

		return queryParamsToReturn;
	}

	private paginationUpdated = (pagination: any) => {

		this.setState(() => ({
			loaded: false,
			pagination: pagination
		}), () => ContentProducerService.getContentList([["pageId", this.state.pagination.pageIndex + 1], ["pageSize", this.state.pagination.pageSize]], this.getContentListsCallback, this.getContentListsCallback));

	}

	private deleteContentList = (id: string) => {

		this.setState(() => ({
			loaded: false
		}));

		if((this.state.contentLists.length - 1) % this.state.pagination.pageSize === 0 && this.state.pagination.pageIndex !== 0){
				this.setState((prevState) => ({
						pagination: {
								...prevState.pagination,
								pageIndex: this.state.pagination.pageIndex -1
						}
				}));
		};

		ContentProducerService.deleteContentList(id, this.deleteContentListCallback, this.deleteContentListErrorCallback)
	}

	private deleteContentListCallback = (id: string) => {
		this.setState(() => ({
			loaded: true
		}));

		this.props.enqueueSnackbar(t({
			id: "mcl-success-delete",
			message: "Lista di contenuti eliminata con successo"
		}), {
			variant: "success",
		});

		ContentProducerService.getContentList([["pageId", this.state.pagination.pageIndex + 1], ["pageSize", this.state.pagination.pageSize]], this.getContentListsCallback, this.getContentListsCallback);
	}

	private deleteContentListErrorCallback = (id: string) => {
		this.setState(() => ({
			loaded: true
		}));

		this.props.enqueueSnackbar(t({
			id: "mcl-error-delete",
			message: "Si è verificato un errore. La lista di contenuti non è stata eliminata"
		}), {
			variant: "error",
		});
	}



	private goToCreate = (): void => {
		let { history } = this.props
		history.push(`/backoffice/create-content-list`);

	}

	render() {
		return (
			<Box sx={{ textAlign: "center", p: 5 }}>
				<NavigationBack/>
				<Typography variant="h2" color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
					<Trans id="mcl-content-list-text-title">Liste contenuti</Trans>
				</Typography>
				{/*<Box sx={{mt: 4}}>
					<ManageContentListFilter sendDataFn={this.submitForm} />
				</Box>*/}
				<Box sx={{ textAlign: "right", pr: 2 }}>
					<Button
						endIcon={<AddIcon />}
						onClick={this.goToCreate}
						variant={"contained"}
					>
						<Trans id="mcl-button-add">Aggiungi</Trans>
					</Button>
				</Box>
				{this.state.loaded && <Box sx={{ p: 2, mt: 2 }}>
					<ContentListTable
						pagination={this.state.pagination}
						contentLists={this.state.contentLists}
						totalContentListsCount={this.state.contentListsCount}
						deleteContentList={this.deleteContentList}
						updatePaginationCallBackFn={this.paginationUpdated}
					/>
				</Box>}
				{!this.state.loaded && <ZPlayLoader />}
			</Box>);
	}
}

export default withUseFormHook<{}>(withRouter(withSnackbar(ManageContentList)), ManageContentListSchema, {});
